module.exports = __webpack_public_path__ + "/images/ico-google-play.1a76557.svg";